import { renderToString } from 'react-dom/server'

const columns = [
  {
    data: 'name',
    className: 'bold',
    width: '37%',
    render: function (data, type, row, meta) {
      return renderToString(
        <a href={row['url']}>{data}</a>
      )
    },
  },
  {
    data: 'type',
    className: 'light',
    width: '18%',
    render: function (data, type, row, meta) {
      if (row['secondary_type']) {
        return renderToString(
          <>
            <span>{row['primary_type']}</span>
            <span className='ellipsis'></span>
            <span>{row['secondary_type']}</span>
          </>
        )
      } else {
        return row['primary_type']
      }
    },
  },
  {
    data: 'created_by',
    width: '20%',
    orderable: false,
    render: (data) => renderToString(<span>{data}</span>)
  },
  {
    data: 'organisation',
    width: '18%',
    render: (data) => renderToString(<span>{data}</span>)
  },
  {
    data: 'id',
    width: '7%',
    className: 'center',
    render: (data, type, row) => {
      return renderToString(
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <button className="button secondary small approve-campaign-button" data-campaign-id={data} data-scheduled-for={row['scheduled_for']}>Approve</button>
          <button className="button red small reject-campaign-button" data-campaign-id={data}>Reject</button>
        </div>
      )
    }
  }
]

const headers = [
  'Name',
  'Campaign type',
  'Created by',
  'Organisation',
  ''
]

const filters = []

const sorters = []

const order = []

export { columns, headers, filters, sorters, order }
